export default __webpack_public_path__ + "static/media/smu-logo.69960783.svg";